<template>
 
     <div class="swiper26" v-if="swiperList2.length > 0">
        <div class="title">
          <img src="@/assets/2026/font.png" alt="">
        </div>
        <swiper class="swiper-container vertical-swiper" :options="swiperOption" ref="diySwiper">
          <swiper-slide v-for="(item, index) in swiperList2" :key="index">
            <img :src="item.img" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
 
</template>
<script>
import Vue from 'vue'
import VueAwesomeSwiper, { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import banner1 from '@/assets/2026/1.jpg'
import banner2 from '@/assets/2026/2.jpg'
import banner3 from '@/assets/2026/3.jpg'
import banner4 from '@/assets/2026/4.jpg'
import banner5 from '@/assets/2026/5.jpg'
import banner6 from '@/assets/2026/6.jpg'
Vue.use(VueAwesomeSwiper)

export default {
  name: 'DiySwiper',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    const that = this
    return {
      swiperList2: [],
      swiperList22: [
        {
          img: banner1,
          text: '',
          link: '',
        }, {
          img: banner2,
          text: '',
          link: '',
        }, {
          img: banner3,
          text: '',
          link: '',
        }, {
          img: banner4,
          text: '',
          link: '',
        }, {
          img: banner5,
          text: '',
          link: '',
        }, {
          img: banner6,
          text: '',
          link: '',
        }
      ],
      swiperOption: {
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 20,
        effect: 'slide',
        grabCursor: true,
        keyboard: {
            enabled: true,
        }
      },
    }
  },
  setup() {
    return {};
  },
  methods: {
    // handleExplore(item) {
    //   this.$router.push(item.data.url)
    //   window._hmt.push(['_trackEvent', '官网首页', '车型探索', item.title]);
    // },
  },
  mounted() {
     setTimeout(() => {
        this.swiperList2 = this.swiperList22
     }, 800);
  },

};
</script>
<style scoped lang="scss">
.vertical-swiper {
  height: auto;
  width: 100%;
  margin: 0;
  padding: 0 0 80px;
  /* background-color: #000; */
  background-size: cover;
  position: relative;
  z-index: 10;
}

/* 分页器样式 */
.vertical-swiper :deep(.swiper-pagination) {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  z-index: 10;
}

.vertical-swiper :deep(.swiper-pagination-bullet) {
  width: 70px;
  height: 5px;
  background-color: #e2e2e2;
  border-radius: 1px;
  opacity: 1;
  margin: 0 5px;
  transition: all 0.3s ease;
}

.vertical-swiper :deep(.swiper-pagination-bullet-active) {
  background-color: #ffd200;
  width: 70px;
}

.vertical-swiper .swiper-wrapper {
  height: 100%;
  align-items: center;
}

.vertical-swiper .swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;  box-sizing: border-box;
  width: 25%;
  opacity: 1;
}

.vertical-swiper .swiper-slide-active {
  opacity: 1;
  width: 50%;
}

.vertical-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  min-height: 100%;
  min-width: 100%;
  border-radius: 10px;
}

.vertical-swiper .swiper-slide-active img {
 
}

.vertical-swiper .swiper-slide {
 
}
.swiper26 {
  position: relative;
  width: 100%;
  height: auto;
  background: url(@/assets/2026/bg.jpg) no-repeat center bottom;
  background-size: cover;
  /* min-height: 100vh; */
  padding-bottom: 16.6%;
}

/* .swiper26 .bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
  z-index: 0;
} */

.swiper26 .title {
  padding: 100px 0 70px;
  max-width: 50%;
  margin: 0 auto;
  z-index: 11;
}

.swiper26 .title img {
  max-width: 100%;
  height: auto;
}

@media screen and (min-width: 1680px ) and (max-width: 1920px) {
  .swiper26 .title {
    padding: 80px 0 50px;
  }
  .vertical-swiper {
    padding: 0 0 60px;
  }
}

@media screen and (min-width: 1440px ) and (max-width: 1680px) {
  .swiper26 .title {
    padding: 80px 0 60px;
  }
  .vertical-swiper {
    padding: 0 0 60px;
  }
}

@media screen and (min-width: 1280px ) and (max-width: 1440px) {
  .swiper26 .title {
    padding: 80px 0 60px;
  }
  .vertical-swiper {
    padding: 0 0 60px;
  }
}
@media screen and (min-width: 960px ) and (max-width: 1280px) {
  .swiper26 .title {
    padding: 60px 0 40px;
  }
  .vertical-swiper {
    padding: 0 0 40px;
  }
}
</style>
